/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-1",
    "aws_cognito_identity_pool_id": "us-west-1:da32bdea-b8b4-4447-b46b-091d70536a16",
    "aws_cognito_region": "us-west-1",
    "aws_user_pools_id": "us-west-1_fjww77B1i",
    "aws_user_pools_web_client_id": "70hdd62id9lttm1jlknq7s1okm",
    "oauth": {
        "domain": "saddlefitstaging.auth.us-west-1.amazoncognito.com",
        "scope": [
            "email",
            "openid",
            "phone",
            "profile"
        ],
        "redirectSignIn": "http://localhost:3000/dashboard",
        "redirectSignOut": "http://localhost:3000/dashboard",
        "responseType": "token"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "GIVEN_NAME",
        "FAMILY_NAME"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "saddlefit-internal-saddlefitpublicbucket-zruitjver5hc",
    "aws_user_files_s3_bucket_region": "us-west-1"
};


export default awsmobile;